<div class="loading-spinner-container">
  <mat-spinner></mat-spinner>
  <p>Generando el reporte, por favor espere...</p>
</div>
